"use client";

import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

interface AceenaSymbolShapeProps {
  className?: string;
  delay?: number;
  size?: number;
  rotate?: number;
  variant?: "mint" | "navy";
}

export function AceenaSymbolShape({
  className,
  delay = 0,
  size = 400,
  rotate = 0,
  variant = "mint",
}: AceenaSymbolShapeProps) {
  const glowColor = variant === "mint" 
    ? "bg-[#7EF5E5]/15" 
    : "bg-[#122649]/10";

  return (
    <motion.div
      initial={{
        opacity: 0,
        y: -150,
        rotate: rotate - 15,
      }}
      animate={{
        opacity: 1,
        y: 0,
        rotate: rotate,
      }}
      transition={{
        duration: 2.4,
        delay,
        ease: [0.23, 0.86, 0.39, 0.96],
        opacity: { duration: 1.2 },
      }}
      className={cn("absolute", className)}
    >
      <motion.div
        animate={{
          y: [0, 18, 0],
        }}
        transition={{
          duration: 12,
          repeat: Infinity,
          ease: "easeInOut",
        }}
        style={{
          width: size,
          height: size,
        }}
        className="relative"
      >
        {/* Glow effect */}
        <div
          className={cn(
            "absolute inset-0 rounded-full blur-3xl",
            glowColor
          )}
        />
        
        {/* Symbol image */}
        <img
          src="/favicon.ico"
          alt=""
          className={cn(
            "absolute inset-0 w-full h-full object-contain",
            variant === "mint" ? "opacity-25" : "opacity-15"
          )}
          style={{
            filter: variant === "navy" 
              ? "brightness(0.3) sepia(1) hue-rotate(180deg) saturate(3)" 
              : undefined,
          }}
        />
      </motion.div>
    </motion.div>
  );
}
